import { Card, Stack, ThemeProvider, Typography, alpha } from '@mui/material';
import { baseTheme } from 'design-system';
import { getTheme } from 'services/theming';
import useUser from 'hooks/useUser';
import { AdminProfile, ButtonVariant, CardFragment as CardData } from 'generated/graphql';
import ActionButton from './ActionButton';
import BtnIcon from './BtnIcon';
import { useWhiteLabelling } from './WhiteLabellingProvider';

export const ButtonCard = ({
  data,
  onClick,
  disabled = false,
  loading = false,
}: {
  data: CardData;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}) => {
  const cardColor = data.color?.toLowerCase();
  const { isSeller, isBuyer, isNileUser } = useUser();
  const { isInputsProfile } = useWhiteLabelling();

  const getButtonTheme = () => {
    if (isSeller && isNileUser) return getTheme(AdminProfile.NileInputs);
    else if (isBuyer && isInputsProfile) return getTheme(AdminProfile.Nile);
    else return baseTheme;
  };

  return (
    <ThemeProvider theme={getButtonTheme()}>
      <Card
        elevation={0}
        sx={(theme) => ({
          backgroundColor:
            cardColor === 'primary'
              ? alpha(theme.palette.primary.main, 0.2)
              : cardColor === 'secondary'
                ? alpha(theme.palette.secondary.main, 0.2)
                : '',
          marginY: cardColor ? theme.spacing(2) : theme.spacing(1),
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: cardColor === '' ? 0 : theme.spacing(2),
        })}
      >
        {data.title && (
          <Stack direction="row" sx={(theme) => ({ alignItems: 'center', marginBottom: theme.spacing(1) })}>
            {data.icon && <BtnIcon icon={data.icon} />}
            <Stack>
              <Typography
                variant="body1"
                sx={(theme) => ({ margin: 0, fontWeight: theme.typography.fontWeightMedium })}
              >
                {data.title}
              </Typography>
              {data.description && <Typography variant="caption">{data.description}</Typography>}
            </Stack>
          </Stack>
        )}
        <ActionButton
          {...data.button}
          size="medium"
          fullWidth={data.button.variant !== ButtonVariant.Text}
          disabled={disabled || data.button.disabled}
          loading={loading}
          onClick={onClick}
        />
      </Card>
    </ThemeProvider>
  );
};

export default ButtonCard;
